<div class="dropdown" id="{{dropdownId}}">
    <div class="dropdown-select" (click)="dropDownClick()">
        <span class="dropdown-title"><tra slug={{title}}></tra></span>
        <div class="caret"></div>
    </div>
    <ul class="dropdown-menu">
        <ng-content></ng-content>
    </ul>
</div>